import { FormInput, FormInputProps, FormLabel } from "@ariakit/react";
import { ReactElement } from "react";
import * as css from "./style.css";
import { useMediaQuery } from "@indietabletop/appkit/use-media-query";
import { MinWidth } from "../media";

export function ReadonlyField(props: {
  name: string;
  label: string;
  value: string;
}) {
  const { name, label, ...inputProps } = props;
  return (
    <div className={css.container}>
      <label htmlFor={name} className={css.label}>
        {label}
      </label>

      <input {...inputProps} name={name} className={css.input} readOnly />
    </div>
  );
}

export function FormField(props: {
  name: FormInputProps["name"];
  label: string;
  placeholder: string;
  render?: ReactElement;
  autoFocusOnWide?: boolean;
  value?: string;
  readOnly?: boolean;
}) {
  const isWide = useMediaQuery(MinWidth.WIDE);
  const { name, label, autoFocusOnWide, ...inputProps } = props;
  const autoFocus = isWide && autoFocusOnWide

  return (
    <div className={css.container}>
      <FormLabel name={name} className={css.label}>
        {label}
      </FormLabel>

      <FormInput
        {...inputProps}
        autoFocus={autoFocus}
        name={name}
        data-1p-ignore
        className={css.input}
      />
    </div>
  );
}
